import React from 'react';

import Authorization from '@appComponents/Authorization';
import LinkWithAuthorization from '@appComponents/LinkWithAuthorization';
import {IconCheckmark, IconEdit} from '@appComponents/IconCollection';
import {getLink} from '@appComponents/Link';
import {PRODUCT} from '@constants/resources';
import {authorizationObject} from '@modules/product/components/Table/authorizationObject';

export const RowRenderer = (column, row) => {
    switch (column) {
        case 'id':
        case 'name':
            return (
                <LinkWithAuthorization
                    authorization={authorizationObject}
                    link={{
                        name: 'products.edit',
                        params: {id: row.id},
                    }}
                >
                    {row[column]}
                </LinkWithAuthorization>
            );
        case 'short_name':
            return row.short_name;
        case 'cdn':
            return row[column] ? row[column].name : null;
        case 'live_ingest_method':
            return row[column] ? row[column].name : null;
        case 'recording_ingest_method':
            return row[column] ? row[column].name : null;
        case 'akamai_cdn_ingest_method':
            return null !== row[column] ? row[column].name : null;
        case 'has_akamai_rtmp_distr_region_support':
        case 'has_scoreboard_overlay_support':
        case 'has_slate_support':
        case 'has_overlay_support':
        case 'has_ad_support':
        case 'has_cc_support':
        case 'has_hq_support':
        case 'has_ll_support':
        case 'has_drm_support':
        case 'has_watermarking_support':
        case 'has_usage_type_support':
        case 'has_geolocation_support':
        case 'has_event_booking_support':
        case 'has_event_group_notification_support':
        case 'has_report':
        case 'is_invoiceable':
        case 'is_betting':
            return !row[column] ? '' : <IconCheckmark/>;
        case 'clip_lifetime':
            return null !== row[column] ? `${row[column]} min` : null;
        case 'sla_minimum_threshold':
            return null !== row[column] ? `${row[column]}%` : null;
        case 'actions' :
            return (
                <Authorization authorization={authorizationObject}>
                    <div className='actions-list-icon'>
                        <IconEdit size='large' link={
                            getLink('products.edit', {id: row.id})
                        } resource={PRODUCT}/>
                    </div>
                </Authorization>
            );
        default:
            return null;
    }
};
